import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { useDebugState } from 'Context/DebugContext';
import DevRelationshipButton from './DevRelationshipButton';

const useStyles = buildUseStyles('DevRelationshipButtons', (() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  rootHidden: { display: 'none' },
})));

const DevRelationshipButtons = ({ resource, onClick }) => {
  const { showDevElements } = useDebugState();

  const classes = useStyles();

  const relationships = resource.relationships().list();

  if (!showDevElements) {
    return null;
  }

  if (!onClick) {
    return null;
  }

  return (
    <Box
      className={classNames(classes.root, {
        [classes.rootHidden]: relationships.length === 0,
      })}
    >
      {relationships.map((rel) => {
        return (
          <DevRelationshipButton
            key={rel.id()}
            relationship={rel}
            onClick={() => {
              onClick(rel);
            }}
          />
        );
      })}
    </Box>
  );
};

DevRelationshipButtons.propTypes = {
  resource: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default DevRelationshipButtons;
